import { jsx } from 'react/jsx-runtime';
import { Flex } from '../Flex/Flex.js';

const CarouselSlide = ({ label, children, selected = false, ...props }) => (jsx(Flex, { alignItems: "center", display: selected ? 'flex' : 'none', role: "group", "aria-roledescription": "slide", "aria-label": label, justifyContent: "center", height: "124px", width: "100%", ...props, children: children }));

export { CarouselSlide };
